// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mi-0";
export var fileList = "_mi-2";
export var removeFileButton = "_mi-1";